module.exports = __webpack_public_path__ + "img/EE.7f08fc0f.svg";